import type { AccountDeletionImpact } from "@/hooks/useAccounts";

type Translate = (key: string, options: { count: number }) => string;

export const getAccountDeletionImpactDetails = (impact: AccountDeletionImpact, t: Translate) => {
  const details: Array<[string, number]> = [
    ["accounts.deletionImpact.transactions", impact.transactions_to_delete],
    ["accounts.deletionImpact.transfers", impact.transfers_as_destination_to_delete],
    ["accounts.deletionImpact.installments", impact.installments_to_delete],
    ["accounts.deletionImpact.importRows", impact.import_rows_to_unlink],
  ];

  return details.filter(([, count]) => count > 0).map(([key, count]) => t(key, { count }));
};
